import { render, staticRenderFns } from "./RegistryCountdown.vue?vue&type=template&id=0a6a1de0&"
import script from "./RegistryCountdown.vue?vue&type=script&lang=js&"
export * from "./RegistryCountdown.vue?vue&type=script&lang=js&"
import style0 from "./RegistryCountdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports